import { gql } from '@apollo/client';

export const GET_TOP_WEBSITES = gql`
  query GetTopWebsites($filters: DistributionGraphsInput) {
    getTopWebsites(input: $filters) {
      amountOfListings
      label
    }
  }
`;
